<!-- components/GlobalLoginDialog.vue -->
<template>
    <div>
        <el-dialog
            v-model="loginManager.visible"
            title="登录"
            width="400px"
            :before-close="handleCancel"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            destroy-on-close
            append-to-body
        >
            <el-form
            ref="loginFormRef"
            :model="form"
            :rules="rules"
            label-width="80px"
            :disabled="loginManager.loading"
            >
            <el-form-item label="账号" prop="username">
                <el-input
                v-model="form.username"
                placeholder="请输入用户名/邮箱"
                :prefix-icon="User"
                clearable
                />
            </el-form-item> 
            <el-form-item label="密码" prop="password">
                <el-input
                v-model="form.password"
                type="password"
                placeholder="请输入密码"
                :prefix-icon="Lock"
                show-password
                clearable
                @keyup.enter="handleSubmit"
                />
            </el-form-item>
            <el-form-item>
                <div class="flex-space-between">
                <el-checkbox v-model="form.remember">记住我</el-checkbox>
                <el-link type="primary" :underline="hover">忘记密码？</el-link>
                </div>
            </el-form-item>
            </el-form>
            
            <template #footer>
            <span class="dialog-footer">
                <el-button @click="handleCancel" :disabled="loginManager.loading">取消</el-button>
                <el-button type="primary" @click="handleSubmit" :loading="loginManager.loading">
                    {{ loginManager.loading ? '登录中...' : '登录' }}
                </el-button>
            </span>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, reactive, nextTick } from 'vue'
import { User, Lock } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import { loginManager } from '@/utils/loginManager'
import { goLogin} from '@/api/common/login.js'

const emit = defineEmits(['handleSuccess'])

// 表单引用
const loginFormRef = ref()
// 表单数据
const form = reactive({
  username: '',
  password: '',
  remember: false
})

// 表单验证规则
const rules = reactive({
  username: [
    { required: true, message: '请输入账号', trigger: 'blur' },
    { min: 3, max: 20, message: '账号长度在 3 到 20 个字符', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
  ]
})

// 处理取消
const handleCancel = () => {
  if (!loginManager.loading) {
    loginManager.cancel()
  }
}

// 处理登录提交
const handleSubmit = async () => {
  // 验证表单
  if (!loginFormRef.value) return
  
  const valid = await loginFormRef.value.validate()
  if (!valid) return
  
  try {
    let param = {
      username: form.username,
      password: form.password
    }
    goLogin(param).then(res =>{
      if(res.code == 200){ 
        localStorage.setItem('loginUser', form.username)

        // 如果勾选了记住我，可以保存到 localStorage
        if (form.remember) {
          localStorage.setItem('rememberedUsername', form.username)
        }
         // 触发登录成功
        loginManager.success(res.data.accessToken)
        
        // 清空表单
        Object.assign(form, {
          username: '',
          password: '',
          remember: false
        })
        console.log('登录成功')
        emit('handleSuccess')
      } else {
        ElMessage.error('账号或密码错误');
      }
    }) 
  } catch (error) {
    console.error('登录失败:', error)
    ElMessage.error('登录失败：' + (error.message || '网络错误'))
  } finally {
    
  }
}
  
// 监听弹窗显示，自动聚焦到输入框
import { watch } from 'vue'
watch(() => loginManager.visible, (visible) => {
  if (visible) { 
    nextTick(() => {
      // 如果有记住的账号，自动填充
      const rememberedUsername = localStorage.getItem('rememberedUsername')
      if (rememberedUsername) {
        form.username = rememberedUsername
        form.remember = true
      }
      // 聚焦到用户名输入框
      const input = document.querySelector('.el-dialog input[type="text"]')
      if (input) {
        input.focus()
      }
    })
  }
})
</script>

<style scoped>
.flex-space-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

/* 可以自定义弹窗样式 */
:deep(.el-dialog) {
  border-radius: 8px;
}

:deep(.el-dialog__header) {
  margin: 0;
  padding: 20px 20px 10px;
  border-bottom: 1px solid #f0f0f0;
}

:deep(.el-dialog__body) {
  padding: 20px;
}

:deep(.el-dialog__footer) {
  padding: 10px 20px 20px;
  border-top: 1px solid #f0f0f0;
}
</style>